import {BoostStatementInterface, RuleItemInterface} from './interfaces';
import NumberHelper from 'helpers/number-helper';
import Const from 'const';

export function isAnyPlayerAbsentInRuleItem(ruleItem: RuleItemInterface, players): boolean {
    const playerIds: string[] = [];

    if (ruleItem.isStatementTypePlayer()) {
        playerIds.push(ruleItem.getKeyPlayer());
    }

    ruleItem.getBoostStatements().map((boostStatement) => {
        boostStatement.isBoostForPlayer() && playerIds.push(boostStatement.getBoostedPlayer());
    });

    for (let playerId of playerIds) {
        if (players.getPlayer(playerId) === null) {
            return true;
        }
    }

    return false;
}

export function calcBoostedPoints(points: number, boostStatement: BoostStatementInterface): number {
    const boostValue = normalizePoints((points / 100) * boostStatement.getBoostPercent());

    return boostStatement.isBoostTypeIncrease() ? boostValue : -1 * boostValue;
}

export function normalizePoints(points: number): number {
    return NumberHelper.float(points, 3);
}

export function createLineupProjectionBoostMap(
    simplexLineup,
    projectionBoostRule,
    players,
): {[playerId: string]: BoostStatementInterface} {
    const projectionBoostMap = {};

    if (!projectionBoostRule.isEnabled()) {
        return projectionBoostMap;
    }

    const duplicateUnits = simplexLineup.getSplitted(Const.LP_DUPLICATE_UNIT_PREFIX);

    duplicateUnits.map((duplicateUnit) => {
        const [boostStatementId, playerId] = duplicateUnit;
        const boostStatement = projectionBoostRule.getStatement(boostStatementId);

        boostStatement && (projectionBoostMap[playerId] = boostStatement);
    });

    return projectionBoostMap;
}

export function isKeyPlayerLineupPositionUsed(sportConfig): boolean {
    return sportConfig.isGameTypeShowDownOrSingleGame() &&
        (sportConfig.isSportNfl() || sportConfig.isSportNba());
}
